'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dLogin$002dPage$002dView$0024$0024anon$002421 from "./presto.-Login-Page-View$$anon$21.js";
import * as $j_presto$002e$002dLogin$002dPage$002dView$0024$0024anon$00247 from "./presto.-Login-Page-View$$anon$7.js";
import * as $j_presto$002etypes$0024$002dSingle$002dApp$002dToken$0024 from "./presto.types$-Single-App-Token$.js";
var $p;
/** @constructor */
function $c_Lpresto_LoginPageView$$anon$6() {
  this.b7W = null;
  this.b7O = null;
  this.b7P = false;
  this.b7X = null;
  this.b7Y = false;
  this.b81 = null;
  this.b7U = null;
  this.b7V = false;
  this.b7Q = null;
  this.b7R = false;
  this.b7S = null;
  this.b7T = false;
  this.b7Z = false;
  this.b80 = false;
  this.b7W = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.b81 = "SingleAppToken";
}
export { $c_Lpresto_LoginPageView$$anon$6 as $c_Lpresto_LoginPageView$$anon$6 };
$p = $c_Lpresto_LoginPageView$$anon$6.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_LoginPageView$$anon$6;
/** @constructor */
function $h_Lpresto_LoginPageView$$anon$6() {
}
export { $h_Lpresto_LoginPageView$$anon$6 as $h_Lpresto_LoginPageView$$anon$6 };
$h_Lpresto_LoginPageView$$anon$6.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.b7W;
});
$p.M = (function() {
  if ((!this.b7P)) {
    this.b7O = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.b7P = true;
  }
  return this.b7O;
});
$p.O = (function() {
  if ((!this.b7Y)) {
    this.b7X = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.b7Y = true;
  }
  return this.b7X;
});
$p.D = (function() {
  return this.b81;
});
$p.t = (function() {
  if ((!this.b7V)) {
    this.b7U = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("created", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("expires", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("user", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.b7V = true;
  }
  return this.b7U;
});
$p.N = (function() {
  if ((!this.b7R)) {
    this.b7Q = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().GU(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$OptionDecoder($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().GU())), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dLogin$002dPage$002dView$0024$0024anon$00247.$c_Lpresto_LoginPageView$$anon$7(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))));
    this.b7R = true;
  }
  return this.b7Q;
});
$p.Q = (function() {
  if ((!this.b7T)) {
    this.b7S = new $j_presto$002e$002dLogin$002dPage$002dView$0024$0024anon$002421.$c_Lpresto_LoginPageView$$anon$21();
    this.b7T = true;
  }
  return this.b7S;
});
$p.v = (function() {
  if ((!this.b80)) {
    this.b7Z = false;
    this.b80 = true;
  }
  return this.b7Z;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee134) => ((p) => \u03b4scrutinee134.adK(p)))($j_presto$002etypes$0024$002dSingle$002dApp$002dToken$0024.$m_Lpresto_types$SingleAppToken$())));
});
var $d_Lpresto_LoginPageView$$anon$6 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_LoginPageView$$anon$6, "presto.LoginPageView$$anon$6", ({
  Ms: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_LoginPageView$$anon$6 as $d_Lpresto_LoginPageView$$anon$6 };
//# sourceMappingURL=presto.-Login-Page-View$$anon$6.js.map
